import { getVideoFirstFrameImage } from '@wanxin-site/common-utils';

/** 帖子媒体封面：优先清晰图 / 模糊图，视频兜底取 OSS 首帧 */
export function getForumMediaCoverUrl(media = {}) {
  if (media.picUrl) return media.picUrl;
  if (media.picBlurryUrl) return media.picBlurryUrl;
  if (media.videoUrl) return getVideoFirstFrameImage(media.videoUrl);
  return '';
}

/** 列表态背景图 style */
export function getForumMediaBackgroundStyle(media = {}) {
  const url = getForumMediaCoverUrl(media);
  return {
    backgroundImage: url ? `url(${url})` : 'none',
  };
}
